export const URL = 'https://c61437.na4u.ru'
export const MAIN_ROUTE = '/strahovanie-ipoteky'

export const TYPES_OBJECTS = [
    { text: 'Квартира', comment: 'online' },
    { text: 'Комната', comment: 'менеджер' },
    { text: 'Частный дом', comment: 'менеджер' },
    { text: 'Апартаменты', comment: 'online' },
    { text: 'Таунхаус', comment: 'менеджер' },
    { text: 'Коммерческая', comment: 'менеджер' },
]

export const list_banks = [
    { value: '1', label: 'Сбербанк', companies: ['absolute', 'zetta'] },
    { value: '2', label: 'ВТБ-банк', companies: ['zetta'] },
    { value: '3', label: 'ПРОМСВЯЗЬБАНК' },
    { value: '4', label: 'ДОМ.РФ Банк' },
    { value: '5', label: 'Газпромбанк' },
    { value: '6', label: 'Райффайзенбанк' },
    { value: '7', label: 'ЮНИКРЕДИТ БАНК' },
    { value: '8', label: 'Санкт-Петербург Банк' },
    { value: '9', label: 'Московский Кредитный Банк' }, 
    { value: '10', label: 'АБ Россия' }, 
    { value: '11', label: 'МЕТАЛЛИНВЕСТБАНК' }, 
    { value: '12', label: 'Москоммерцбанк' }, 
    { value: '13', label: 'ТРАНСКАПИТАЛ БАНК' },
    { value: '14', label: 'Совкомбанк' },
    { value: '15', label: 'Банк ЗЕНИТ' },
    { value: '16', label: 'ВБРР Банк' },
    { value: '17', label: 'СМП Банк' },
    { value: '18', label: 'НОВИКОМБАНК' },
    { value: '19', label: 'ПРИМСОЦБАНК' },
    { value: '20', label: 'УРАЛ ФД БАНК' },
    { value: '21', label: 'ИНТЕРПРОГРЕССБАНК' },
    { value: '22', label: 'ЧЕЛЯБИНВЕСТБАНК' },
    { value: '23', label: 'УРАЛПРОМБАНК' },
    { value: '24', label: 'БАНК РОСТ-ФИНАНС' },
    { value: '25', label: 'СЕВЕРГАЗБАНК' },
    { value: '26', label: 'ЭНЕРГОБАНК' },
    { value: '27', label: 'ТАТСОЦБАНК' },
    { value: '28', label: 'БАНК АВЕРС' },
    { value: '29', label: 'КОШЕЛЕВ-БАНК' },
    { value: '30', label: 'БАНК САРАТОВ' },
    { value: '31', label: 'ИНВЕСТТОРГБАНК' },
    { value: '32', label: 'МТС Банк' },
    { value: '33', label: 'НИКО-БАНК' },
    { value: '34', label: 'БАНК АКЦЕПТ' },
    { value: '35', label: 'ГЕНБАНК' },
    { value: '36', label: 'НОРВИК БАНК' },
    { value: '37', label: 'РНКБ БАНК' },

]

export const list_month = [
    { value: '1', label: 'Январь 2024' },
    { value: '2', label: 'Февраль 2024' },
    { value: '3', label: 'Март 2024' },
    { value: '4', label: 'Апрель 2024' },
    { value: '5', label: 'Май 2024' },
    { value: '6', label: 'Июнь 2024' },
    { value: '7', label: 'Июль 2024' },
    { value: '8', label: 'Август 2024' },
    { value: '9', label: 'Сентябрь 2024' },
    { value: '10', label: 'Октябрь 2024' },
    { value: '11', label: 'Ноябрь 2024' },
    { value: '12', label: 'Декабрь 2024' },
    { value: '13', label: 'Январь 2025' },
    { value: '14', label: 'Февраль 2025' },
    { value: '15', label: 'Март 2025' },
    { value: '16', label: 'Апрель 2025' },
    { value: '17', label: 'Май 2025' },
    { value: '18', label: 'Июнь 2025' },
    { value: '19', label: 'Июль 2025' },
    { value: '20', label: 'Август 2025' },
    { value: '21', label: 'Сентябрь 2025' },
    { value: '22', label: 'Октябрь 2025' },
    { value: '23', label: 'Ноябрь 2025' },
    { value: '24', label: 'Декабрь 2025' },
    { value: '25', label: 'Январь 2026' },
    { value: '26', label: 'Февраль 2026' },
    { value: '27', label: 'Март 2026' },
    { value: '28', label: 'Апрель 2026' },
    { value: '29', label: 'Май 2026' },
    { value: '30', label: 'Июнь 2026' },
    { value: '31', label: 'Июль 2026' },
    { value: '32', label: 'Август 2026' },
    { value: '33', label: 'Сентябрь 2026' },
    { value: '34', label: 'Октябрь 2026' },
    { value: '35', label: 'Ноябрь 2026' },
    { value: '36', label: 'Декабрь 2026' },
    { value: '37', label: 'Январь 2027' },
];

export const listGender = [
    {label: 'Мужской', value: 'm'},
    {label: 'Женский', value: 'f'}
]

export const listPreassureUp = [
    { value: '1', label: '100 - 135' },
    { value: '2', label: '136 - 140' },
    { value: '3', label: '141 - 145' },
    { value: '4', label: '146 - 150' },
    { value: '5', label: '151 - 155' },
    { value: '6', label: '156 - 160' },
    { value: '7', label: '161 - 165' },
    { value: '8', label: '166 - 170' }
]

export const listPreassureBot = [
    { value: '1', label: 'до 95' },
    { value: '2', label: '96 - 100' },
    { value: '3', label: '101 - 105' },
    { value: '4', label: '106 и более' }
]

export const listSmoking = [
    {label: 'Не курю', value: false},
    {label: 'Курю', value: true}
]

export const listAlcohol = [
    {label: 'Не употребляю', value: false},
    {label: 'Употребляю', value: true}
]

export const listIsNewestBuilding = [
    {label: 'Нет', value: false},
    {label: 'Да', value: true}
]

export const listIsPublicPerson = [
    {label: 'Нет', value: false},
    {label: 'Да', value: true}
]

// building
export const listNumLevels = [
    {label: 1, value: 1},
    {label: 2, value: 2},
    {label: 3, value: 3},
    {label: 4, value: 4},
    {label: 5, value: 5},
    {label: 6, value: 6},
    {label: 7, value: 7},
    {label: 8, value: 8},
    {label: 9, value: 9},
    {label: 10, value: 10},
    {label: 11, value: 11},
    {label: 12, value: 12},
    {label: 13, value: 13},
    {label: 14, value: 14},
    {label: 15, value: 15},
    {label: 16, value: 16},
    {label: 17, value: 17},
    {label: 18, value: 18},
    {label: 19, value: 19},
    {label: 20, value: 20},
    {label: 21, value: 21},
    {label: 22, value: 22},
    {label: 23, value: 23},
    {label: 24, value: 24},
    {label: 25, value: 25},
    {label: 26, value: 26},
    {label: 27, value: 27},
    {label: 28, value: 28},
    {label: 29, value: 29},
    {label: 30, value: 30},
]

export const listMaterialBuild = [
    {label: "Горючий", value: true},
    {label: "Не горючий", value: false}
]

export const listFire = [
    {label: "Да", value: true},
    {label: "Нет", value: false}
]

export const listNumRooms = [
    {label: 1, value: 1},
    {label: 2, value: 2},
    {label: 3, value: 3},
    {label: 4, value: 4},
    {label: 5, value: 5},
    {label: 6, value: 6},
    {label: 7, value: 7},
    {label: 8, value: 8},
    {label: 9, value: 9},
    {label: 10, value: 10}
]

export const profs =
[
    {
        value: "1",
        label: "Автогонщик"
    },
    {
        value: "2",
        label: "Автомеханик"
    },
    {
        value: "3",
        label: "Агент по туризму"
    },
    {
        value: "4",
        label: "Агроном"
    },
    {
        value: "5",
        label: "Адвокат"
    },
    {
        value: "6",
        label: "Администратор базы данных"
    },
    {
        value: "7",
        label: "Администратор гостиницы"
    },
    {
        value: "8",
        label: "Администратор ресторана"
    },
    {
        value: "9",
        label: "Администратор сайта"
    },
    {
        value: "10",
        label: "Актер"
    },
    {
        value: "11",
        label: "Акушер"
    },
    {
        value: "12",
        label: "Аналитик"
    },
    {
        value: "13",
        label: "Анестезиолог"
    },
    {
        value: "14",
        label: "Аниматор"
    },
    {
        value: "15",
        label: "Археолог"
    },
    {
        value: "16",
        label: "Архивариус"
    },
    {
        value: "17",
        label: "Архитектор"
    },
    {
        value: "18",
        label: "Астроном"
    },
    {
        value: "19",
        label: "Аудитор"
    },
    {
        value: "20",
        label: "Банкир"
    },
    {
        value: "21",
        label: "Бармен"
    },
    {
        value: "22",
        label: "Библиограф"
    },
    {
        value: "23",
        label: "Библиотекарь"
    },
    {
        value: "24",
        label: "Бизнес-тренер"
    },
    {
        value: "25",
        label: "Биоинженер"
    },
    {
        value: "26",
        label: "Биолог"
    },
    {
        value: "27",
        label: "Биохимик"
    },
    {
        value: "28",
        label: "Блогер"
    },
    {
        value: "29",
        label: "Блокчейн-разработчик"
    },
    {
        value: "30",
        label: "Бортинженер"
    },
    {
        value: "31",
        label: "Бортпроводник"
    },
    {
        value: "32",
        label: "Ботаник"
    },
    {
        value: "33",
        label: "Бренд-дизайнер"
    },
    {
        value: "34",
        label: "Бренд-менеджер"
    },
    {
        value: "35",
        label: "Брокер"
    },
    {
        value: "36",
        label: "Булочник"
    },
    {
        value: "37",
        label: "Бухгалтер"
    },
    {
        value: "38",
        label: "Веб-дизайнер"
    },
    {
        value: "39",
        label: "Верстальщик"
    },
    {
        value: "40",
        label: "Ветеринар"
    },
    {
        value: "41",
        label: "Визажист"
    },
    {
        value: "42",
        label: "Винодел"
    },
    {
        value: "43",
        label: "Вирусолог"
    },
    {
        value: "44",
        label: "Водолаз"
    },
    {
        value: "45",
        label: "Военнослужащий"
    },
    {
        value: "46",
        label: "Воспитатель"
    },
    {
        value: "47",
        label: "Востоковед"
    },
    {
        value: "48",
        label: "Врач скорой помощи"
    },
    {
        value: "49",
        label: "Врач-диетолог"
    },
    {
        value: "50",
        label: "Выпускающий редактор"
    },
    {
        value: "51",
        label: "Генетик"
    },
    {
        value: "52",
        label: "Геодезист"
    },
    {
        value: "53",
        label: "Геолог"
    },
    {
        value: "54",
        label: "Гид-переводчик"
    },
    {
        value: "55",
        label: "Грузчик"
    },
    {
        value: "56",
        label: "Дата-журналист"
    },
    {
        value: "57",
        label: "Дворник"
    },
    {
        value: "58",
        label: "Дегустатор"
    },
    {
        value: "59",
        label: "Делопроизводитель"
    },
    {
        value: "60",
        label: "Дерматолог"
    },
    {
        value: "61",
        label: "Детектив"
    },
    {
        value: "62",
        label: "Дефектолог"
    },
    {
        value: "63",
        label: "Диджей"
    },
    {
        value: "64",
        label: "Диетолог"
    },
    {
        value: "65",
        label: "Дизайнер-модельер"
    },
    {
        value: "66",
        label: "Диктор"
    },
    {
        value: "67",
        label: "Дипломат"
    },
    {
        value: "68",
        label: "Дирижер"
    },
    {
        value: "69",
        label: "Доярка"
    },
    {
        value: "70",
        label: "Драпировщик"
    },
    {
        value: "71",
        label: "Египтолог"
    },
    {
        value: "72",
        label: "Животновод"
    },
    {
        value: "73",
        label: "Журналист"
    },
    {
        value: "74",
        label: "Звукооператор"
    },
    {
        value: "75",
        label: "Звукорежиссер"
    },
    {
        value: "76",
        label: "Зубной техник"
    },
    {
        value: "77",
        label: "Издатель"
    },
    {
        value: "78",
        label: "Иллюстратор"
    },
    {
        value: "79",
        label: "Иммунолог"
    },
    {
        value: "80",
        label: "ИнженерИнкассатор"
    },
    {
        value: "81",
        label: "Инспектор по охране труда"
    },
    {
        value: "82",
        label: "Искусствовед"
    },
    {
        value: "83",
        label: "Историк"
    },
    {
        value: "84",
        label: "Ихтиолог"
    },
    {
        value: "85",
        label: "Каменщик"
    },
    {
        value: "86",
        label: "Кардиолог"
    },
    {
        value: "87",
        label: "Кардиохирург"
    },
    {
        value: "88",
        label: "Картограф"
    },
    {
        value: "89",
        label: "Каскадер"
    },
    {
        value: "90",
        label: "Кинолог"
    },
    {
        value: "91",
        label: "Киномеханик"
    },
    {
        value: "92",
        label: "Кинооператор"
    },
    {
        value: "93",
        label: "Кинорежиссер"
    },
    {
        value: "94",
        label: "Кладовщик"
    },
    {
        value: "95",
        label: "Композитор"
    },
    {
        value: "96",
        label: "Конвоир"
    },
    {
        value: "97",
        label: "Конструктор"
    },
    {
        value: "98",
        label: "Консультант телефона доверия"
    },
    {
        value: "99",
        label: "Контент-менеджер"
    },
    {
        value: "100",
        label: "Копирайтер"
    },
    {
        value: "101",
        label: "Корректор"
    },
    {
        value: "102",
        label: "Косметолог"
    },
    {
        value: "103",
        label: "Космонавт"
    },
    {
        value: "104",
        label: "Крановщик"
    },
    {
        value: "105",
        label: "Краснодеревщик"
    },
    {
        value: "106",
        label: "Кризис-менеджер"
    },
    {
        value: "107",
        label: "Критик"
    },
    {
        value: "108",
        label: "Кровельщик"
    },
    {
        value: "109",
        label: "Культуролог"
    },
    {
        value: "110",
        label: "Лаборант"
    },
    {
        value: "111",
        label: "Ландшафтный дизайнер"
    },
    {
        value: "112",
        label: "Летчик"
    },
    {
        value: "113",
        label: "Лингвист"
    },
    {
        value: "114",
        label: "Литейщик"
    },
    {
        value: "115",
        label: "Лоббист"
    },
    {
        value: "116",
        label: "Логист"
    },
    {
        value: "117",
        label: "Логопед"
    },
    {
        value: "118",
        label: "Лоцман"
    },
    {
        value: "119",
        label: "Маляр"
    },
    {
        value: "120",
        label: "Маркетолог"
    },
    {
        value: "121",
        label: "Маркшейдер"
    },
    {
        value: "122",
        label: "Массажист"
    },
    {
        value: "123",
        label: "Мастер маникюра"
    },
    {
        value: "124",
        label: "Математик"
    },
    {
        value: "125",
        label: "Машинист"
    },
    {
        value: "126",
        label: "Медсестра"
    },
    {
        value: "127",
        label: "Менеджер"
    },
    {
        value: "128",
        label: "Менеджер по логистике"
    },
    {
        value: "129",
        label: "Менеджер по персоналу"
    },
    {
        value: "130",
        label: "Мерчендайзер"
    },
    {
        value: "131",
        label: "Месильщик"
    },
    {
        value: "132",
        label: "Металлург"
    },
    {
        value: "133",
        label: "Метеоролог"
    },
    {
        value: "134",
        label: "Микробиолог"
    },
    {
        value: "135",
        label: "Мультипликатор"
    },
    {
        value: "136",
        label: "Мусорщик"
    },
    {
        value: "137",
        label: "Мясник"
    },
    {
        value: "138",
        label: "Налоговый инспектор"
    },
    {
        value: "139",
        label: "Нанотехнолог"
    },
    {
        value: "140",
        label: "Невропатолог"
    },
    {
        value: "141",
        label: "Нейрохирург"
    },
    {
        value: "142",
        label: "Нотариус"
    },
    {
        value: "143",
        label: "Облицовщик"
    },
    {
        value: "144",
        label: "Онколог"
    },
    {
        value: "145",
        label: "Оператор call-центра"
    },
    {
        value: "146",
        label: "Орнитолог"
    },
    {
        value: "147",
        label: "Отделочник"
    },
    {
        value: "148",
        label: "Офис-менеджер"
    },
    {
        value: "149",
        label: "Официант"
    },
    {
        value: "150",
        label: "Офтальмолог"
    },
    {
        value: "151",
        label: "Охотник"
    },
    {
        value: "152",
        label: "Оценщик"
    },
    {
        value: "153",
        label: "Палеонтолог"
    },
    {
        value: "154",
        label: "Парикмахер"
    },
    {
        value: "155",
        label: "Педагог"
    },
    {
        value: "156",
        label: "Педиатр"
    },
    {
        value: "157",
        label: "Пекарь"
    },
    {
        value: "158",
        label: "Переводчик"
    },
    {
        value: "159",
        label: "Переплетчик"
    },
    {
        value: "160",
        label: "Печатник"
    },
    {
        value: "161",
        label: "Писатель"
    },
    {
        value: "162",
        label: "Плотник"
    },
    {
        value: "163",
        label: "Повар"
    },
    {
        value: "164",
        label: "Повар-кондитер"
    },
    {
        value: "165",
        label: "Пожарный"
    },
    {
        value: "166",
        label: "Политолог"
    },
    {
        value: "167",
        label: "Полицейский"
    },
    {
        value: "168",
        label: "Портье"
    },
    {
        value: "169",
        label: "Почвовед"
    },
    {
        value: "170",
        label: "Почтальон"
    },
    {
        value: "171",
        label: "Правовед"
    },
    {
        value: "172",
        label: "Преподаватель"
    },
    {
        value: "173",
        label: "Продакт-менеджер"
    },
    {
        value: "174",
        label: "Прокурор"
    },
    {
        value: "175",
        label: "Промышленный альпинист"
    },
    {
        value: "176",
        label: "Прораб"
    },
    {
        value: "177",
        label: "Психолог"
    },
    {
        value: "178",
        label: "Психотерапевт"
    },
    {
        value: "179",
        label: "Пчеловод"
    },
    {
        value: "180",
        label: "Радиоведущий"
    },
    {
        value: "181",
        label: "Разведчик"
    },
    {
        value: "182",
        label: "Редактор"
    },
    {
        value: "183",
        label: "Режиссер"
    },
    {
        value: "184",
        label: "Ректор"
    },
    {
        value: "185",
        label: "Религиовед"
    },
    {
        value: "186",
        label: "Реставратор"
    },
    {
        value: "187",
        label: "Риелтор"
    },
    {
        value: "188",
        label: "Садовник"
    },
    {
        value: "189",
        label: "Секретарь"
    },
    {
        value: "190",
        label: "Сетевой инженер"
    },
    {
        value: "191",
        label: "Системный администратор"
    },
    {
        value: "192",
        label: "Системный аналитик"
    },
    {
        value: "193",
        label: "Скульптор"
    },
    {
        value: "194",
        label: "Следователь"
    },
    {
        value: "195",
        label: "Слесарь"
    },
    {
        value: "196",
        label: "Социолог"
    },
    {
        value: "197",
        label: "Спасатель"
    },
    {
        value: "198",
        label: "Специалист по информационной безопасности"
    },
    {
        value: "199",
        label: "Спичрайтер"
    },
    {
        value: "200",
        label: "Спортивный врач"
    },
    {
        value: "201",
        label: "Спортивный инструктор"
    },
    {
        value: "202",
        label: "Спортивный тренер"
    },
    {
        value: "203",
        label: "Спортсмен"
    },
    {
        value: "204",
        label: "Статистик"
    },
    {
        value: "205",
        label: "Стилист"
    },
    {
        value: "206",
        label: "Столяр"
    },
    {
        value: "207",
        label: "Стоматолог"
    },
    {
        value: "208",
        label: "Страховой агент"
    },
    {
        value: "209",
        label: "Строитель"
    },
    {
        value: "210",
        label: "Стюардесса"
    },
    {
        value: "211",
        label: "Судебный пристав"
    },
    {
        value: "212",
        label: "Судья"
    },
    {
        value: "213",
        label: "Супервайзер"
    },
    {
        value: "214",
        label: "Сурдопедагог"
    },
    {
        value: "215",
        label: "Сценарист"
    },
    {
        value: "216",
        label: "Таксист"
    },
    {
        value: "217",
        label: "Татуировщик"
    },
    {
        value: "218",
        label: "Тележурналист"
    },
    {
        value: "219",
        label: "Телохранитель"
    },
    {
        value: "220",
        label: "Терапевт"
    },
    {
        value: "221",
        label: "Тестировщик"
    },
    {
        value: "222",
        label: "Технический писатель"
    },
    {
        value: "223",
        label: "Технолог"
    },
    {
        value: "224",
        label: "Тифлопедагог"
    },
    {
        value: "225",
        label: "Товаровед"
    },
    {
        value: "226",
        label: "Торговый представитель"
    },
    {
        value: "227",
        label: "Тракторист"
    },
    {
        value: "228",
        label: "Трейдер"
    },
    {
        value: "229",
        label: "Тюремный надзиратель"
    },
    {
        value: "230",
        label: "Учитель"
    },
    {
        value: "231",
        label: "Фальцовщик"
    },
    {
        value: "232",
        label: "Фармацевт"
    },
    {
        value: "233",
        label: "Фельдшер"
    },
    {
        value: "234",
        label: "Фермер"
    },
    {
        value: "235",
        label: "Философ"
    },
    {
        value: "236",
        label: "Финансист"
    },
    {
        value: "237",
        label: "Финансовый аналитик"
    },
    {
        value: "238",
        label: "Флорист"
    },
    {
        value: "239",
        label: "Фотограф"
    },
    {
        value: "240",
        label: "Фотомодель"
    },
    {
        value: "241",
        label: "Химик"
    },
    {
        value: "242",
        label: "Хореограф"
    },
    {
        value: "243",
        label: "Часовщик"
    },
    {
        value: "244",
        label: "Шеф-повар"
    },
    {
        value: "245",
        label: "Штурман"
    },
    {
        value: "246",
        label: "Эколог"
    },
    {
        value: "247",
        label: "Экономист"
    },
    {
        value: "248",
        label: "Экскурсовод"
    },
    {
        value: "249",
        label: "Экспедитор"
    },
    {
        value: "250",
        label: "Электрик"
    },
    {
        value: "251",
        label: "Этнограф"
    },
    {
        value: "252",
        label: "Ювелир"
    },
    {
        value: "253",
        label: "Юрист"
    },
    {
        value: "254",
        label: "Event-менеджер"
    },
    {
        value: "255",
        label: "HTML-верстальщик"
    },
    {
        value: "256",
        label: "Product-менеджер"
    },
    {
        value: "257",
        label: "PR-менеджер"
    },
    {
        value: "258",
        label: "SMM-менеджер"
    },
    {
        value: "259",
        label: "WEB-дизайнер"
    },
    {
        value: "260",
        label: "WEB-интеграторбезопасности"
    },
    {
        value: "261",
        label: "Специалист таможенного дела"
    },
    {
        value: "262",
        label: "Специалист операционного отдела"
    },
    {
        value: "263",
        label: "Консультант"
    },
    {
        value: "264",
        label: "Сварщик"
    },
    {
        value: "265",
        label: "Шлифовщик"
    },
    {
        value: "266",
        label: "Программист"
    },
    {
        value: "267",
        label: "Капитан-механик"
    },
    {
        value: "268",
        label: "Водитель"
    },
    {
        value: "269",
        label: "Водитель-экспедитор"
    },
    {
        value: "270",
        label: "Сотрудник метрополитена"
    },
    {
        value: "271",
        label: "Инспектор службы"
    }
]



export const JOBS = [
    {
        value: "1",
        label: "Авиадиспетчер"
    },
    {
        value: "2",
        label: "Автогонщик"
    },
    {
        value: "3",
        label: "Автомеханик"
    },
    {
        value: "4",
        label: "Агент по туризму"
    },
    {
        value: "5",
        label: "Агроном"
    },
    {
        value: "6",
        label: "Адвокат"
    },
    {
        value: "7",
        label: "Администратор базы данных"
    },
    {
        value: "8",
        label: "Администратор гостиницы"
    },
    {
        value: "9",
        label: "Администратор ресторана"
    },
    {
        value: "10",
        label: "Администратор сайта"
    },
    {
        value: "11",
        label: "Актер"
    },
    {
        value: "12",
        label: "Акушер"
    },
    {
        value: "13",
        label: "Аналитик"
    },
    {
        value: "14",
        label: "Анестезиолог"
    },
    {
        value: "15",
        label: "Аниматор"
    },
    {
        value: "16",
        label: "Археолог"
    },
    {
        value: "17",
        label: "Архивариус"
    },
    {
        value: "18",
        label: "Архитектор"
    },
    {
        value: "19",
        label: "Астроном"
    },
    {
        value: "20",
        label: "Аудитор"
    },
    {
        value: "21",
        label: "Банкир"
    },
    {
        value: "22",
        label: "Бармен"
    },
    {
        value: "23",
        label: "Библиограф"
    },
    {
        value: "24",
        label: "Библиотекарь"
    },
    {
        value: "25",
        label: "Бизнес-тренер"
    },
    {
        value: "26",
        label: "Биоинженер"
    },
    {
        value: "27",
        label: "Биолог"
    },
    {
        value: "28",
        label: "Биохимик"
    },
    {
        value: "29",
        label: "Блогер"
    },
    {
        value: "30",
        label: "Блокчейн-разработчик"
    },
    {
        value: "31",
        label: "Бортинженер"
    },
    {
        value: "32",
        label: "Бортпроводник"
    },
    {
        value: "33",
        label: "Ботаник"
    },
    {
        value: "34",
        label: "Бренд-дизайнер"
    },
    {
        value: "35",
        label: "Бренд-менеджер"
    },
    {
        value: "36",
        label: "Брокер"
    },
    {
        value: "37",
        label: "Булочник"
    },
    {
        value: "38",
        label: "Бухгалтер"
    },
    {
        value: "39",
        label: "Веб-дизайнер"
    },
    {
        value: "40",
        label: "Верстальщик"
    },
    {
        value: "41",
        label: "Ветеринар"
    },
    {
        value: "42",
        label: "Визажист"
    },
    {
        value: "43",
        label: "Винодел"
    },
    {
        value: "44",
        label: "Вирусолог"
    },
    {
        value: "45",
        label: "Водолаз"
    },
    {
        value: "46",
        label: "Военнослужащий"
    },
    {
        value: "47",
        label: "Воспитатель"
    },
    {
        value: "48",
        label: "Востоковед"
    },
    {
        value: "49",
        label: "Врач скорой помощи"
    },
    {
        value: "50",
        label: "Врач-диетолог"
    },
    {
        value: "51",
        label: "Выпускающий редактор"
    },
    {
        value: "52",
        label: "Генетик"
    },
    {
        value: "53",
        label: "Геодезист"
    },
    {
        value: "54",
        label: "Геолог"
    },
    {
        value: "55",
        label: "Гид-переводчик"
    },
    {
        value: "56",
        label: "Грузчик"
    },
    {
        value: "57",
        label: "Дата-журналист"
    },
    {
        value: "58",
        label: "Дворник"
    },
    {
        value: "59",
        label: "Дегустатор"
    },
    {
        value: "60",
        label: "Делопроизводитель"
    },
    {
        value: "61",
        label: "Дерматолог"
    },
    {
        value: "62",
        label: "Детектив"
    },
    {
        value: "63",
        label: "Дефектолог"
    },
    {
        value: "64",
        label: "Диджей"
    },
    {
        value: "65",
        label: "Диетолог"
    },
    {
        value: "66",
        label: "Дизайнер-модельер"
    },
    {
        value: "67",
        label: "Диктор"
    },
    {
        value: "68",
        label: "Дипломат"
    },
    {
        value: "69",
        label: "Дирижер"
    },
    {
        value: "70",
        label: "Доярка"
    },
    {
        value: "71",
        label: "Драпировщик"
    },
    {
        value: "72",
        label: "Египтолог"
    },
    {
        value: "73",
        label: "Животновод"
    },
    {
        value: "74",
        label: "Журналист"
    },
    {
        value: "75",
        label: "Звукооператор"
    },
    {
        value: "76",
        label: "Звукорежиссер"
    },
    {
        value: "77",
        label: "Зубной техник"
    },
    {
        value: "78",
        label: "Издатель"
    },
    {
        value: "79",
        label: "Иллюстратор"
    },
    {
        value: "80",
        label: "Иммунолог"
    },
    {
        value: "81",
        label: "ИнженерИнкассатор"
    },
    {
        value: "82",
        label: "Инспектор по охране труда"
    },
    {
        value: "83",
        label: "Искусствовед"
    },
    {
        value: "84",
        label: "Историк"
    },
    {
        value: "85",
        label: "Ихтиолог"
    },
    {
        value: "86",
        label: "Каменщик"
    },
    {
        value: "87",
        label: "Кардиолог"
    },
    {
        value: "88",
        label: "Кардиохирург"
    },
    {
        value: "89",
        label: "Картограф"
    },
    {
        value: "90",
        label: "Каскадер"
    },
    {
        value: "91",
        label: "Кинолог"
    },
    {
        value: "92",
        label: "Киномеханик"
    },
    {
        value: "93",
        label: "Кинооператор"
    },
    {
        value: "94",
        label: "Кинорежиссер"
    },
    {
        value: "95",
        label: "Кладовщик"
    },
    {
        value: "96",
        label: "Композитор"
    },
    {
        value: "97",
        label: "Конвоир"
    },
    {
        value: "98",
        label: "Конструктор"
    },
    {
        value: "99",
        label: "Консультант телефона доверия"
    },
    {
        value: "100",
        label: "Контент-менеджер"
    },
    {
        value: "101",
        label: "Копирайтер"
    },
    {
        value: "102",
        label: "Корректор"
    },
    {
        value: "103",
        label: "Косметолог"
    },
    {
        value: "104",
        label: "Космонавт"
    },
    {
        value: "105",
        label: "Крановщик"
    },
    {
        value: "106",
        label: "Краснодеревщик"
    },
    {
        value: "107",
        label: "Кризис-менеджер"
    },
    {
        value: "108",
        label: "Критик"
    },
    {
        value: "109",
        label: "Кровельщик"
    },
    {
        value: "110",
        label: "Культуролог"
    },
    {
        value: "111",
        label: "Лаборант"
    },
    {
        value: "112",
        label: "Ландшафтный дизайнер"
    },
    {
        value: "113",
        label: "Летчик"
    },
    {
        value: "114",
        label: "Лингвист"
    },
    {
        value: "115",
        label: "Литейщик"
    },
    {
        value: "116",
        label: "Лоббист"
    },
    {
        value: "117",
        label: "Логист"
    },
    {
        value: "118",
        label: "Логопед"
    },
    {
        value: "119",
        label: "Лоцман"
    },
    {
        value: "120",
        label: "Маляр"
    },
    {
        value: "121",
        label: "Маркетолог"
    },
    {
        value: "122",
        label: "Маркшейдер"
    },
    {
        value: "123",
        label: "Массажист"
    },
    {
        value: "124",
        label: "Мастер маникюра"
    },
    {
        value: "125",
        label: "Математик"
    },
    {
        value: "126",
        label: "Машинист"
    },
    {
        value: "127",
        label: "Медсестра"
    },
    {
        value: "128",
        label: "Менеджер"
    },
    {
        value: "129",
        label: "Менеджер по логистике"
    },
    {
        value: "130",
        label: "Менеджер по персоналу"
    },
    {
        value: "131",
        label: "Мерчендайзер"
    },
    {
        value: "132",
        label: "Месильщик"
    },
    {
        value: "133",
        label: "Металлург"
    },
    {
        value: "134",
        label: "Метеоролог"
    },
    {
        value: "135",
        label: "Микробиолог"
    },
    {
        value: "136",
        label: "Мультипликатор"
    },
    {
        value: "137",
        label: "Мусорщик"
    },
    {
        value: "138",
        label: "Мясник"
    },
    {
        value: "139",
        label: "Налоговый инспектор"
    },
    {
        value: "140",
        label: "Нанотехнолог"
    },
    {
        value: "141",
        label: "Невропатолог"
    },
    {
        value: "142",
        label: "Нейрохирург"
    },
    {
        value: "143",
        label: "Нотариус"
    },
    {
        value: "144",
        label: "Облицовщик"
    },
    {
        value: "145",
        label: "Онколог"
    },
    {
        value: "146",
        label: "Оператор call-центра"
    },
    {
        value: "147",
        label: "Орнитолог"
    },
    {
        value: "148",
        label: "Отделочник"
    },
    {
        value: "149",
        label: "Офис-менеджер"
    },
    {
        value: "150",
        label: "Официант"
    },
    {
        value: "151",
        label: "Офтальмолог"
    },
    {
        value: "152",
        label: "Охотник"
    },
    {
        value: "153",
        label: "Оценщик"
    },
    {
        value: "154",
        label: "Палеонтолог"
    },
    {
        value: "155",
        label: "Парикмахер"
    },
    {
        value: "156",
        label: "Педагог"
    },
    {
        value: "157",
        label: "Педиатр"
    },
    {
        value: "158",
        label: "Пекарь"
    },
    {
        value: "159",
        label: "Переводчик"
    },
    {
        value: "160",
        label: "Переплетчик"
    },
    {
        value: "161",
        label: "Печатник"
    },
    {
        value: "162",
        label: "Писатель"
    },
    {
        value: "163",
        label: "Плотник"
    },
    {
        value: "164",
        label: "Повар"
    },
    {
        value: "165",
        label: "Повар-кондитер"
    },
    {
        value: "166",
        label: "Пожарный"
    },
    {
        value: "167",
        label: "Политолог"
    },
    {
        value: "168",
        label: "Полицейский"
    },
    {
        value: "169",
        label: "Портье"
    },
    {
        value: "170",
        label: "Почвовед"
    },
    {
        value: "171",
        label: "Почтальон"
    },
    {
        value: "172",
        label: "Правовед"
    },
    {
        value: "173",
        label: "Преподаватель"
    },
    {
        value: "174",
        label: "Продакт-менеджер"
    },
    {
        value: "175",
        label: "Прокурор"
    },
    {
        value: "176",
        label: "Промышленный альпинист"
    },
    {
        value: "177",
        label: "Прораб"
    },
    {
        value: "178",
        label: "Психолог"
    },
    {
        value: "179",
        label: "Психотерапевт"
    },
    {
        value: "180",
        label: "Пчеловод"
    },
    {
        value: "181",
        label: "Радиоведущий"
    },
    {
        value: "182",
        label: "Разведчик"
    },
    {
        value: "183",
        label: "Редактор"
    },
    {
        value: "184",
        label: "Режиссер"
    },
    {
        value: "185",
        label: "Ректор"
    },
    {
        value: "186",
        label: "Религиовед"
    },
    {
        value: "187",
        label: "Реставратор"
    },
    {
        value: "188",
        label: "Риелтор"
    },
    {
        value: "189",
        label: "Садовник"
    },
    {
        value: "190",
        label: "Секретарь"
    },
    {
        value: "191",
        label: "Сетевой инженер"
    },
    {
        value: "192",
        label: "Системный администратор"
    },
    {
        value: "193",
        label: "Системный аналитик"
    },
    {
        value: "194",
        label: "Скульптор"
    },
    {
        value: "195",
        label: "Следователь"
    },
    {
        value: "196",
        label: "Слесарь"
    },
    {
        value: "197",
        label: "Социолог"
    },
    {
        value: "198",
        label: "Спасатель"
    },
    {
        value: "199",
        label: "Специалист по информационной безопасности"
    },
    {
        value: "200",
        label: "Спичрайтер"
    },
    {
        value: "201",
        label: "Спортивный врач"
    },
    {
        value: "202",
        label: "Спортивный инструктор"
    },
    {
        value: "203",
        label: "Спортивный тренер"
    },
    {
        value: "204",
        label: "Спортсмен"
    },
    {
        value: "205",
        label: "Статистик"
    },
    {
        value: "206",
        label: "Стилист"
    },
    {
        value: "207",
        label: "Столяр"
    },
    {
        value: "208",
        label: "Стоматолог"
    },
    {
        value: "209",
        label: "Страховой агент"
    },
    {
        value: "210",
        label: "Строитель"
    },
    {
        value: "211",
        label: "Стюардесса"
    },
    {
        value: "212",
        label: "Судебный пристав"
    },
    {
        value: "213",
        label: "Судья"
    },
    {
        value: "214",
        label: "Супервайзер"
    },
    {
        value: "215",
        label: "Сурдопедагог"
    },
    {
        value: "216",
        label: "Сценарист"
    },
    {
        value: "217",
        label: "Таксист"
    },
    {
        value: "218",
        label: "Татуировщик"
    },
    {
        value: "219",
        label: "Тележурналист"
    },
    {
        value: "220",
        label: "Телохранитель"
    },
    {
        value: "221",
        label: "Терапевт"
    },
    {
        value: "222",
        label: "Тестировщик"
    },
    {
        value: "223",
        label: "Технический писатель"
    },
    {
        value: "224",
        label: "Технолог"
    },
    {
        value: "225",
        label: "Тифлопедагог"
    },
    {
        value: "226",
        label: "Товаровед"
    },
    {
        value: "227",
        label: "Торговый представитель"
    },
    {
        value: "228",
        label: "Тракторист"
    },
    {
        value: "229",
        label: "Трейдер"
    },
    {
        value: "230",
        label: "Тюремный надзиратель"
    },
    {
        value: "231",
        label: "Учитель"
    },
    {
        value: "232",
        label: "Фальцовщик"
    },
    {
        value: "233",
        label: "Фармацевт"
    },
    {
        value: "234",
        label: "Фельдшер"
    },
    {
        value: "235",
        label: "Фермер"
    },
    {
        value: "236",
        label: "Философ"
    },
    {
        value: "237",
        label: "Финансист"
    },
    {
        value: "238",
        label: "Финансовый аналитик"
    },
    {
        value: "239",
        label: "Флорист"
    },
    {
        value: "240",
        label: "Фотограф"
    },
    {
        value: "241",
        label: "Фотомодель"
    },
    {
        value: "242",
        label: "Химик"
    },
    {
        value: "243",
        label: "Хореограф"
    },
    {
        value: "244",
        label: "Часовщик"
    },
    {
        value: "245",
        label: "Шеф-повар"
    },
    {
        value: "246",
        label: "Штурман"
    },
    {
        value: "247",
        label: "Эколог"
    },
    {
        value: "248",
        label: "Экономист"
    },
    {
        value: "249",
        label: "Экскурсовод"
    },
    {
        value: "250",
        label: "Экспедитор"
    },
    {
        value: "251",
        label: "Электрик"
    },
    {
        value: "252",
        label: "Этнограф"
    },
    {
        value: "253",
        label: "Ювелир"
    },
    {
        value: "254",
        label: "Юрист"
    },
    {
        value: "255",
        label: "Event-менеджер"
    },
    {
        value: "256",
        label: "HTML-верстальщик"
    },
    {
        value: "257",
        label: "Product-менеджер"
    },
    {
        value: "258",
        label: "PR-менеджер"
    },
    {
        value: "259",
        label: "SMM-менеджер"
    },
    {
        value: "260",
        label: "WEB-дизайнер"
    },
    {
        value: "261",
        label: "WEB-интегратор"
    },
    {
        value: "262",
        label: "Специалист таможенного дела"
    },
    {
        value: "263",
        label: "Специалист операционного отдела"
    },
    {
        value: "264",
        label: "Консультант"
    },
    {
        value: "265",
        label: "Сварщик"
    },
    {
        value: "266",
        label: "Шлифовщик"
    },
    {
        value: "267",
        label: "Программист"
    },
    {
        value: "268",
        label: "Капитан-механик"
    },
    {
        value: "269",
        label: "Водитель"
    },
    {
        value: "270",
        label: "Водитель-экспедитор"
    },
    {
        value: "271",
        label: "Сотрудник метрополитена"
    },
    {
        value: "272",
        label: "Инспектор службы безопасности"
    }
]  